import PropTypes from "prop-types";
import React from "react";
import LeadLink from "web/react/components/lead-link/lead-link";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./product-description-express-checkout-disclaimer.css";

function ProductDescriptionExpressCheckoutDisclaimer(_ref) {
  var retailerName = _ref.retailerName,
      leadUrl = _ref.leadUrl,
      productId = _ref.productId;
  return React.createElement("div", {
    className: styles.express_checkout_disclaimer
  }, React.createElement("div", {
    className: styles.or
  }, gettext("in_stock_product.or_separator")), React.createElement(LeadLink, {
    href: leadUrl,
    productId: productId,
    openInNewTab: true,
    reason: "retailer-ec-disclaimer"
  }, React.createElement("p", {
    className: styles.disclaimer
  }, React.createElement("span", {
    className: styles.copy
  }, gettext("product.buy_area.size_stock_disclaimer", {})), retailerName)));
}

export default ProductDescriptionExpressCheckoutDisclaimer;
ProductDescriptionExpressCheckoutDisclaimer.propTypes = {
  retailerName: PropTypes.string.isRequired,
  leadUrl: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired
};